<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
    
    <!-- detalles -->
    <v-row>
      <v-col
        sm="1"
        lg="2"
        class="hidden-xs-only"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs" 
              v-on="on" 
              @click="regresar"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>
      <v-col 
        cols="12" 
        sm="10" 
        lg="8"
      >
        <DetailCard
          title="Detalles Categoria"
          :loading="cardLoading"
        >
          <v-row justify="center">
            <v-col 
              cols="12" 
              sm="10" 
              lg="8"
            >
              <p class="text-h6 font-weight-bold">
                Categoria
              </p>
              <p class="text-subtitle-1">
                {{ categoria.categoria }}
              </p>
            </v-col>

            <v-col 
              cols="12" 
              sm="10" 
              lg="8"
            >
              <p class="text-h6 font-weight-bold">
                Descripción
              </p>
              <template v-if="categoria.descripcion != null">
                <p class="text-subtitle-1">
                  {{ categoria.descripcion }}
                </p>
              </template>
              <template v-else>
                <p class="text-subtitle-1">
                  No registrada
                </p>
              </template>
            </v-col>

            <v-col 
              cols="12" 
              sm="10" 
              lg="8"
            >
              <p class="text-h6 font-weight-bold">
                Aliados
              </p>
              <template v-if="aliados.length > 0">
                <p v-for="(item, i) in aliados" :key="i"
                  class="text-subtitle-1"
                >
                  {{ item.aliado }}
                </p>
              </template>

              <template v-else>
                <p class="text-subtitle-1">
                  No registrados
                </p>
              </template>
            </v-col>

            <v-col 
              cols="12" 
              sm="10" 
              lg="8"
            >
              <p class="text-h6 font-weight-bold">
                Documento de Lineamientos
              </p>
              <template v-if="documento.length > 0">
                <v-btn
                  color="blue-grey"
                  class="ma-2 white--text"
                  @click="descargarDocumento()"
                >
                  Descargar
                  <v-icon
                    right
                    dark
                  >
                    mdi-cloud-download
                  </v-icon>
                </v-btn>
              </template>
              <template v-else>
                <p class="text-subtitle-1">
                  No registrado
                </p>
              </template>
            </v-col>
          </v-row>
        </DetailCard>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Alert from '../../../components/admin/Alert.vue';
import DetailCard from '../../../components/admin/DetailCard.vue';

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',
    documento: [], 
    aliados: [] ,  
    cardLoading: true,
  }),

  mounted() {
    this.$store.dispatch("gestionarAliados")
    this.$store.dispatch("obtenerCategoriaCampesenaId", this.$route.params.idCategoria)
      setTimeout(() => {
        this.cardLoading = false
      }, 1000)  
  },
  
  computed: {
  categoria() {
    return this.$store.getters.obtenerCategoriaCampesena
  },
    aliado() {
      return this.$store.getters.obtenerAliados
    }
  },

  components: {
    Alert, 
    DetailCard
  },

  methods: {
    regresar() {
      this.$router.back()
    },

    descargarDocumento() {
      this.$store.dispatch("downloadDocumentoLineamentos", {
        categoria_id: this.$route.params.id_categoria,
        tipo_documento_id: 7
      })
      .then((response) => {
        const urlReporte = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href= urlReporte
        link.setAttribute('download', `Lineamientos-${this.categoria.categoria}.pdf`)
        document.body.appendChild(link)
        link.click();
      })
      .catch(() => {
        this.alertType    = "error--text";
        this.alertTitle   = "Error";
        this.alertMessage = `La categoria ${this.categoria.categoria} no tiene lineamientos registrados`;
        this.alert        = true;
      })
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
  }
};
</script>